import { ArrowDropDown, ArrowRight } from "@mui/icons-material";
import { FormControl, FormLabel, Typography, RadioGroup, FormControlLabel, Radio, TextField, Divider } from "@mui/material";
import { useState } from "react";
import { HeaderConditionType } from "./BaseFilter";

export interface UsernameFilter {
    filterType: "username"
    conditionType: HeaderConditionType
    filter: string
}

export interface UserFilterOptionsProps {
    id: string
    state?: UsernameFilter
    setState: (u?: UsernameFilter) => void
}

export function UserFilterOption(props: UserFilterOptionsProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onChangeValue = (newValue: string) => {
        props.setState({
            ...props.state!,
            filter: newValue,
        });
    };

    return (
        <>
            {
                <FormControl sx={{ marginTop: "20px" }} component="fieldset">
                    <FormLabel id={props.id} component="legend" sx={{ display: "flex", alignItems: "center", cursor: "pointer", ":hover": { color: "primary.main" } }}
                        onClick={() => setIsOpen(!isOpen)} >
                        {isOpen ? <ArrowDropDown /> : <ArrowRight />}<Typography component={"span"} sx={{ fontWeight: "bold" }}>Username</Typography>
                    </FormLabel>
                    <Divider variant="fullWidth" sx={{ marginTop: "5px"}} />
                    {isOpen ? <RadioGroup
                        aria-label="obfuscated"
                        name="radio-obfuscated"
                        sx={{ marginLeft: "25px" }}
                        value={props.state?.conditionType}
                        onChange={(e, value) => {
                            if (value === "") {
                                props.setState(undefined);
                            } else {
                                props.setState({
                                    filterType: "username",
                                    conditionType: value as HeaderConditionType,
                                    filter: "",
                                });
                            }
                        }}
                    >
                        <FormControlLabel value="equal" control={<Radio />} label="is equal" />
                        {props.state?.conditionType === HeaderConditionType.Equal && <TextField size="small" variant="outlined" value={props.state.filter} onChange={(e) => onChangeValue(e.target.value)} />}
                        <FormControlLabel value="not_equal" control={<Radio />} label="is not equal" />
                        {props.state?.conditionType === HeaderConditionType.NotEqual && <TextField size="small" variant="outlined" value={props.state.filter} onChange={(e) => onChangeValue(e.target.value)} />}
                        <FormControlLabel value="contains" control={<Radio />} label="contains" />
                        {props.state?.conditionType === HeaderConditionType.Contains ? <TextField size="small" variant="outlined" value={props.state.filter} onChange={(e) => onChangeValue(e.target.value)} /> : null}
                        <FormControlLabel value="not_contains" control={<Radio />} label="does not contain" />
                        {props.state?.conditionType === HeaderConditionType.DoesNotContain ? <TextField size="small" variant="outlined" value={props.state.filter} onChange={(e) => onChangeValue(e.target.value)} /> : null}
                    </RadioGroup> : null}
                </FormControl>
            }
        </>);
}